import { FormControl, InputAdornment, InputLabel, TextField } from '@mui/material';
import styled from '@emotion/styled';

// Step 1: Create a styled TextField

const CustomTextField = ({ label, icon: Icon, isWarning = false, ...props }: any) => {
    const StyledTextField = styled(TextField)({
        "& input[type='text']": {
            padding: '12px',
            fontSize: '14px',
            color: isWarning ? '#cd6200' : 'black',
            backgroundColor: '#fff',
            fontFamily: 'Poppins, sans-serif',
        },
        "& .MuiInputBase-root": {
            pointerEvents: 'none',
            borderRadius: '8px !important',
            borderColor: '#D9D9D9'
        }
    });
    return (
        <FormControl fullWidth variant="outlined" sx={{}}>
            <InputLabel htmlFor={props.id} sx={{ top: '-45px', left: '-10px', color: 'black', fontSize: '14px' }}>
                {label}
            </InputLabel>
            <StyledTextField
                {...props}
                id={props.id}
                sx={{ color: 'orange' }}
                slotProps={{
                    input: {
                        startAdornment: (
                            <InputAdornment position="start">
                                {Icon && <Icon />}
                            </InputAdornment>
                        ),
                    }
                }
                }
            />
        </FormControl>
    );
};

export default CustomTextField;
